import { render } from "./add.vue?vue&type=template&id=d85f3ab4"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"
script.render = render

export default script